import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Wallet, CheckCircle2 } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await register(name, email, password);
    setLoading(false);
    if (res.ok) setSuccess(true);
    else setError(res.error);
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2 bg-[#F9F8F6]">
      <div className="hidden md:block relative sand-bg">
        <div className="absolute inset-0 bg-gradient-to-br from-[#8A5A44]/40 via-transparent to-[#2D2C2A]/40" />
        <div className="relative z-10 h-full flex flex-col justify-between p-12 text-white">
          <div />
          <div />
        </div>
      </div>

      <div className="flex items-center justify-center p-8 fade-in">
        <div className="w-full max-w-md">
          {success ? (
            <div className="text-center" data-testid="register-success">
              <div className="w-16 h-16 rounded-full bg-[#4A6741]/15 text-[#4A6741] flex items-center justify-center mx-auto mb-6">
                <CheckCircle2 size={32} strokeWidth={1.75} />
              </div>
              <h1 className="font-heading text-3xl sm:text-4xl text-[#2D2C2A] mb-4 leading-tight">Kayıt talebiniz alındı</h1>
              <p className="text-[#5C5B57] mb-8">
                Hesabınız yönetici onayı bekliyor. Onaylandıktan sonra giriş yapabilirsiniz.
              </p>
              <Link to="/login" data-testid="back-to-login"
                className="inline-block bg-[#8A5A44] text-white hover:bg-[#714835] rounded-xl px-6 py-3 font-medium">
                Giriş Sayfasına Dön
              </Link>
            </div>
          ) : (
            <>
          <p className="text-xs tracking-[0.2em] uppercase font-bold text-[#5C5B57] mb-3">Ücretsiz kayıt</p>
          <h1 className="font-heading text-4xl sm:text-5xl text-[#2D2C2A] mb-4 leading-tight">Hesap oluşturun</h1>
          <p className="text-sm text-[#5C5B57] mb-8">Kayıt sonrası yönetici onayı gereklidir.</p>
          <form onSubmit={submit} className="space-y-5" data-testid="register-form">
            <div>
              <label className="text-xs tracking-[0.15em] uppercase font-bold text-[#5C5B57] mb-2 block">Ad Soyad</label>
              <input required autoComplete="off" value={name} onChange={(e) => setName(e.target.value)}
                placeholder="Adınız Soyadınız"
                data-testid="register-name"
                className="w-full bg-white border border-[#E6E4DD] rounded-xl px-4 py-3 focus:ring-2 focus:ring-[#8A5A44]/20 focus:border-[#8A5A44] outline-none" />
            </div>
            <div>
              <label className="text-xs tracking-[0.15em] uppercase font-bold text-[#5C5B57] mb-2 block">E-posta</label>
              <input type="email" required autoComplete="off" value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="ornek@sirket.com"
                data-testid="register-email"
                className="w-full bg-white border border-[#E6E4DD] rounded-xl px-4 py-3 focus:ring-2 focus:ring-[#8A5A44]/20 focus:border-[#8A5A44] outline-none" />
            </div>
            <div>
              <label className="text-xs tracking-[0.15em] uppercase font-bold text-[#5C5B57] mb-2 block">Şifre (min 6)</label>
              <input type="password" required minLength={6} autoComplete="new-password" value={password} onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                data-testid="register-password"
                className="w-full bg-white border border-[#E6E4DD] rounded-xl px-4 py-3 focus:ring-2 focus:ring-[#8A5A44]/20 focus:border-[#8A5A44] outline-none" />
            </div>
            {error && <div data-testid="register-error" className="text-sm text-[#B24C4C] bg-[#B24C4C]/10 border border-[#B24C4C]/20 rounded-xl px-4 py-3">{error}</div>}
            <button type="submit" disabled={loading} data-testid="register-submit"
              className="w-full bg-[#8A5A44] text-white hover:bg-[#714835] rounded-xl px-6 py-3.5 font-medium transition-all disabled:opacity-60">
              {loading ? "Oluşturuluyor…" : "Hesap Oluştur"}
            </button>
            <p className="text-sm text-[#5C5B57] text-center">
              Zaten hesabınız var mı?{" "}
              <Link data-testid="link-login" to="/login" className="text-[#8A5A44] underline underline-offset-4 font-medium">Giriş yapın</Link>
            </p>
          </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
